module.exports = require("compression");